import React from "react";
import Modal from "../modal-new";
import scriptLoader from "../../utils/scriptLoader";
import submit from "submit-form";
import SvgIcon from "../SvgIcon";
/**
 * Switch elements in array
 * @param {Array} array
 * @param {Number} from
 * @param {Number} to
 * @returns Array with new order
 */
const switchItemPosition = (array, from, to) => {
  const newArray = [...array];
  const item = newArray[from];
  newArray.splice(from, 1);
  newArray.splice(to, 0, item);
  return newArray;
};
const sortDirections = {
  up: "up",
  down: "down",
  custom: "custom",
};
class SortCategoriesModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      categories: [],
      sortedCategories: [],
    };
    this.sortable = null;
    this.handleSort = this.handleSort.bind(this);
    this.getCategoryName = this.getCategoryName.bind(this);
  }

  componentDidMount() {
    const { categories } = this.props;
    this.loadSortable();
    this.setState({
      sortedCategories: categories,
      sortDirection: sortDirections.custom,
    });
  }

  loadSortable() {
    scriptLoader(
      "https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js",
      () => {
        if (typeof Sortable === "undefined") {
          setTimeout(() => {
            this.loadSortable();
          }, 500);
          return;
        }
        const dragImage = document.createElement("img");
        dragImage.src =
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        this.sortable = new Sortable(document.querySelector(".tag-container"), {
          animation: 350,
          handle: ".drag-handle",
          setData(dataTransfer) {
            dataTransfer.setDragImage(dragImage, 0, 0);
          },
          onStart: () => {},
          onEnd: ({ oldIndex, newIndex }) => {
            if (oldIndex === newIndex) return;
            this.setState({
              sortedCategories: switchItemPosition(
                [...this.state.sortedCategories],
                oldIndex,
                newIndex
              ),
            });
          },
        });
      }
    );
  }

  handleSort(direction = "up") {
    const { categories } = this.props;
    if (direction === "custom") {
      this.setState({
        sortedCategories: categories,
        sortDirection: direction,
      });
      return;
    }
    console.log("after the console");
    const cloned = Array.from(categories).sort();
    if (direction !== "up") cloned.reverse();
    this.setState({
      sortedCategories: cloned,
      sortDirection: direction,
    });
  }

  saveChanges() {
    const { sortedCategories } = this.state;
    const {
      categories,
      onSave,
      isCategoryObject = false,
      activeUserToRequest = undefined,
    } = this.props;

    if (sortedCategories.length !== categories.length) return;

    const result = isCategoryObject
      ? sortedCategories.map((category) => category._id)
      : sortedCategories;

    onSave(result);

    const body = isCategoryObject
      ? { sortedCategories }
      : {
          sortedCategories,
          activeUserToRequestId: activeUserToRequest._id,
        };

    submit(
      isCategoryObject
        ? "/actions/admin-panel/manage-category/sort"
        : "/actions/cycle/store/sort-category",
      {
        method: "POST",
        body,
      }
    );
  }

  handleCancel() {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { modal: "" },
    });
  }

  getCategoryName(category, isCategoryObject) {
    if (isCategoryObject) {
      return category.name;
    }
    return category;
  }

  render() {
    const { sortedCategories } = this.state;
    const { onClose, isCategoryObject = false } = this.props;

    return (
      <form onSubmit={(e) => {}} id="add-exercise">
        <Modal
          className="store-sort-cat"
          title={"Edit Categories"}
          onClose={onClose}
        >
          <div className="body">
            <header>
              <label>Sort Categories</label>
              <div className="row">
                <SvgIcon
                  onClickFn={() => this.handleSort("up")}
                  src={`/img/new-icons/${
                    this.state.sortDirection === sortDirections.up
                      ? "checked-square"
                      : "unchecked-square"
                  }.svg`}
                  noFilterOnLight={true}
                />
                <p className="p1">Ascending A-Z</p>
              </div>
              <div className="row">
                <SvgIcon
                  onClickFn={() => this.handleSort("down")}
                  src={`/img/new-icons/${
                    this.state.sortDirection === sortDirections.down
                      ? "checked-square"
                      : "unchecked-square"
                  }.svg`}
                  noFilterOnLight={true}
                />
                <p className="p1">Descending Z-A</p>
              </div>
              <div className="row">
                <SvgIcon
                  onClickFn={() => this.handleSort("custom")}
                  src={`/img/new-icons/${
                    this.state.sortDirection === sortDirections.custom
                      ? "checked-square"
                      : "unchecked-square"
                  }.svg`}
                  noFilterOnLight={true}
                />
                <p className="p1">Custom</p>
              </div>
            </header>
            <section>
              <label className="info-drag">
                Drag and drop to change position
              </label>
              <ul className="tag-container">
                {sortedCategories.map((category, idx) => (
                  <li
                    className="tag"
                    key={`${this.getCategoryName(
                      category,
                      isCategoryObject
                    )}-${idx}`}
                  >
                    {this.getCategoryName(category, isCategoryObject)}
                    {this.state.sortDirection === "custom" && (
                      <img
                        src="/img/new-icons/drag.svg"
                        className="drag-handle"
                      />
                    )}
                  </li>
                ))}
              </ul>
            </section>
          </div>
          <footer className="footer">
            <button
              data-button-type="secondary"
              data-action="cancel"
              onClick={() => this.handleCancel()}
            >
              Cancel
            </button>
            <button
              data-button-type="primary"
              onClick={() => this.saveChanges()}
            >
              Save
            </button>
          </footer>
        </Modal>
      </form>
    );
  }
}

export default SortCategoriesModal;
